<template>
    <div class="top-filters-container">
        <panel-wrapper @apply="onSubmit"
                       @clear="clearFilters"
                       @click="hideCategoriesDropdown"
                       :active="filtersCount>0"
                       :count="filtersCount"
        >
            <h1 slot="header">Wybierz filtry i odszukaj idealny prezent</h1>

            <form action="" method="get" class="mobile-sort-panel-menu-wrapper" slot="content">
                <div class="scrollbar">
                    <ul class="mobile-menu">
                        <li class="mobile-item" v-for="category in categories">
                            <group-category
                                    :title="resolveCategoryName(category)"
                                    :loading="isLoading"
                            >
                                <item-category
                                        v-for="child in category.children"
                                        :key="`categoryItem${child.id}`"
                                        :hide-group-on-click="false"
                                        :loading="isLoading"
                                        :category="child"
                                        :checked-categories="checkedCategories"
                                        @check-category="checkCategory"
                                        @remove-category="removeCategory"
                                />
                            </group-category>

                            <div class="block-content">
                                <item-selected
                                        :style="{ padding: '0 20px'}"
                                        :checked-categories="getGroupedCategories(category.id)"
                                        @remove-category="removeCategory"
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
        </panel-wrapper>
    </div>
</template>

<script>
    import axios from 'axios'
    import EventBus from "./services/EventBus"
    import Autocomplete from "./components/Autocomplete"
    import PanelWrapper from "./components/PanelWrapper"
    import ButtonSearch from "./components/ButtonSearch"
    import ButtonBack from "./components/ButtonBack"
    import ButtonFilter from "./components/ButtonFilter"
    import ItemCategory from "./components/ItemCategory"
    import GroupCategory from "./components/GroupCategory"
    import ItemSelected from "./components/ItemSelected"
    import CategoryHeader from "./components/CategoryHeader";
    import CategoryNameResolver from "./mixins/CategoryNameResolver";

    export default {
        name: "App",
        mixins: [
            CategoryNameResolver
        ],
        components: {
            CategoryHeader,
            ItemSelected,
            ItemCategory,
            GroupCategory,
            ButtonBack,
            ButtonSearch,
            PanelWrapper,
            Autocomplete,
            ButtonFilter
        },
        data() {
            return {
                categoriesGroupId: [
                    CATEGORY_FOR,
                    CATEGORY_OCCASIONS,
                    CATEGORY_FROM_HOBBY,
                    CATEGORY_LIKES,
                    CATEGORY_TYPE,
                    CATEGORY_OCCUPATION,
                ],
                checkedCategories: [],
                isLoading: false,
                categories: null,
                openGroup: null,
            }
        },
        computed: {
            filtersCount() {
                return this.checkedCategories.length;
            }
        },
        methods: {

            /**
             * @param {int} categoryId
             */
            checkCategory(categoryId) {
                if (false === this.checkedCategories.includes(categoryId)) {
                    this.checkedCategories.push(categoryId)
                }
            },

            /**
             * @param {int} categoryId
             */
            removeCategory(categoryId) {
                if (this.checkedCategories.includes(categoryId)) {
                    this.checkedCategories = this.checkedCategories.filter(id => categoryId !== id);
                }
            },

            /**
             * @param {int} categoryId
             * @returns {[]|*[]}
             */
            getGroupedCategories(categoryId) {
                const rootCategory = this.categories.find(category => category.id === categoryId);
                if (rootCategory) {
                    const findCheckedCategories = (category) => {
                        let categories = [];

                        if (category.children.length) {
                            for (let categoryItem of category.children) {
                                const result = findCheckedCategories(categoryItem);
                                categories = [
                                    ...result,
                                    ...categories
                                ]
                            }
                        }

                        if (this.checkedCategories.includes(category.id)) {
                            categories.push(category)
                        }

                        return categories;
                    }
                    return findCheckedCategories(rootCategory);
                }
                return [];
            },

            hideCategoriesDropdown() {
                EventBus.$emit('category-dropdown-hide');
                EventBus.$emit('category-group-hide');
            },

            clearFilters() {
                this.checkedCategories = []

                EventBus.$emit('category-dropdown-hide')
                EventBus.$emit('category-group-hide')
            },

            onSubmit() {
                if ( this.filtersCount > 0) {
                    const url = `lista.php?szukaj[categories]=${this.checkedCategories.join(',')}`;
                    window.location.href = url
                }
                return true
            },

            /**
              * @param {string} search
             */
            onSearch(search) {
                if ( search.length>=3) {
                    window.location.href='lista.php?szukaj[name]='+search
                }
            },

            /**
             * @returns {number[]|*[]}
             */
            getCategoriesIdsFromUrl() {
                let uri = window.location.href.split('?')
                if (uri.length === 2) {
                    let vars = uri[1].split('&')
                    let getVars = {}
                    let tmp = ''
                    vars.forEach(function(v){
                        tmp = v.split('=')
                        if(tmp.length === 2)
                            getVars[tmp[0]] = tmp[1]
                    })
                    let paramCategories = getVars['szukaj[categories]']
                    if ( typeof paramCategories !== "undefined") {
                        return getVars['szukaj[categories]'].split(',').map(value => parseInt(value));
                    }
                }

                return [];
            },

            async ajaxGetCategories() {
                this.isLoading = true;

                if (null != this.cancelToken) {
                    this.cancelToken.cancel()
                    this.cancelToken = null
                }

                try {
                    var CancelToken = axios.CancelToken;
                    this.cancelToken = CancelToken.source();

                    const result = await axios.get('app/filters.php', {
                        cancelToken: this.cancelToken.token,
                        params: {
                            action: 'get_categories',
                            categoriesGroupId: this.categoriesGroupId.toString(),
                        },
                        responseType: 'text'
                    });
                    this.cancelToken = null

                    this.categories = result.data.entries
                    this.checkedCategories = this.getCategoriesIdsFromUrl();
                } catch (error) {
                    if (axios.isCancel(error)) {
                        console.log('Request canceled', error.message)
                    } else {
                        console.log(error)
                    }
                }
                this.isLoading = false
            },
        },
        mounted() {
            this.ajaxGetCategories();
        },
    }

</script>

<style scoped lang="scss">
    @import "../../../../scss/variables";
    @import "../../../../scss/mixins/breakpoint";

    .top-filters-container {
        width: 100%;
        padding: 0;
        position: relative;

        h1 {
            text-align: center;
            margin: 30px auto;
            font-size: 20px;
            @include only-mobile-breakpoint() {
                font-size: 16px;
            }
        }
    }

    .block-content {
        margin: 20px 0;
    }
    .autocomplete-background {
        opacity: 1;
        position: fixed;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: -1;
    }
    .mobile-button-wrapper {
        margin: 0;
        display: block;
        width: 100%;
        padding: 0;
        box-sizing: border-box;
        font-size: 0;
    }

    .scrollbar {
        padding: 0 0 100px 0;
    }

    ul.mobile-menu {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }
    ul.mobile-menu > li {
        float: left;
        width: 14.5%;
        margin: 0 1% 90px 1%;
        padding: 0;
        & > span {
            display: block;
            border: 1px solid #cccccc;
            border-radius: 3px;
        }
    }
    ul.mobile-menu > li:last-of-type {
        margin-right: 0;
    }

    @media (max-width: 960px) {
        ul.mobile-menu > li {
            float: left;
            width: 48%;
            margin-right: 2%;
            margin-bottom: 20px;
        }
    }

    @media (max-width: 1000px) {
        ul.mobile-menu > li {
            float: none;
            width: 100%;
            margin-right: 0;
            margin-bottom: 20px;
            margin-left: 0;
        }
    }

</style>
